import { Box, Button, Divider, Flex, FormControl, FormLabel, HStack, IconButton, Input, Select, Stack, Text, useColorModeValue } from '@chakra-ui/react';
import { Link as DefaultLink, useNavigate, useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { companyUserType, registerFormTypes } from '../../types';
import { useAppDispatch, useAppSelector } from '../../hooks';

import { AppDispatch } from '../../store';
import { FiArrowLeft } from 'react-icons/fi';
import { ToastContainer } from 'react-toastify';
import { registerFormValidation } from '../../utils';
import { updateUser } from '../../store/actions';
import { useFormik } from 'formik';

export const EditUser = () => {

    const { user_id } = useParams();

    const [user, setUser] =useState<companyUserType>();
    const { users } = useAppSelector(state => state.usersReducer);

    const dispatch: AppDispatch = useAppDispatch();

    const navigate = useNavigate();

    const EditUserForm = useFormik({
        initialValues: {
            first_name: '',
            last_name: '',
            email: '',
            phone: '',
            gender: '',
            role: '',
        },
        validationSchema: registerFormValidation,
        validateOnBlur: true,
        onSubmit: (values: registerFormTypes) => {
            const newValues = {...user, ...values};
            dispatch(updateUser(`${user?._id}`, newValues));
        }
    });

    const setUserFormValues = () => {

        const [user] = users?.filter((user: companyUserType) => user?.user_id === user_id);
        setUser(user);

        EditUserForm.setFieldValue('first_name', user?.first_name);
        EditUserForm.setFieldValue('last_name', user?.last_name);
        EditUserForm.setFieldValue('email', user?.email);
        EditUserForm.setFieldValue('phone', user?.phone);
        EditUserForm.setFieldValue('gender', user?.gender);
        EditUserForm.setFieldValue('role', user?.role);

    };

    const handleSubmit = async () => {
        EditUserForm.setSubmitting(true);
        const newValues = {...user, ...EditUserForm?.values};
        await dispatch(updateUser(`${user?._id}`, newValues))
        .then(() => { 
            EditUserForm.setSubmitting(false);
            navigate('/users');
        })
        .catch(() => EditUserForm.setSubmitting(false));
    };

    useEffect(() => {}, []);

    useEffect(() => {
        setUserFormValues();
    }, [user]);

    return (
        <Flex
            minH={'-webkit-fill-available'}
            align={'center'}
            justify={'center'}
            // bg={useColorModeValue('gray.50', 'gray.800')}
            py={10}
        >
            <Stack>
                <Box
                    rounded={'lg'}
                    bg={useColorModeValue('white', 'gray.700')}
                    boxShadow={'lg'}
                    p={8}>
                    <Stack spacing={4}>
                        <HStack align={'center'}>
                            <Stack>
                                <IconButton variant={'ghost'} aria-label='go back' icon={<FiArrowLeft style={{ width: '24px', height: '24px' }} />} as={DefaultLink} to='/users' />
                            </Stack>
                            <Stack>
                                <Text display={'flex'} fontSize={'lg'} fontWeight='medium' textAlign={'center'}>
                                    Edit user.
                                </Text>
                            </Stack>
                        </HStack>
                        <Divider />
                        <Stack mb={3}>
                            <Text textAlign={'center'} fontSize={'lg'} color={'gray.600'}>
                                To enjoy all of our cool features ✌️
                            </Text>
                        </Stack>
                        <form onSubmit={EditUserForm.handleSubmit}>
                            <HStack>
                                <Box minW={'50%'}>
                                    <FormControl id="firstName" isRequired mb={EditUserForm.errors.first_name ? 0 : 5}>
                                        <FormLabel>First name</FormLabel>
                                        <Input name='first_name' type="text" value={EditUserForm.values.first_name} onChange={EditUserForm.handleChange} onBlur={EditUserForm.handleBlur} />
                                        {EditUserForm.errors.first_name && <Text fontSize='sm' color='red.400'>{EditUserForm.errors.first_name}</Text>}
                                    </FormControl>
                                </Box>
                                <Box minW={'50%'}>
                                    <FormControl id="lastName" isRequired mb={EditUserForm.errors.last_name ? 0 : 5}>
                                        <FormLabel>Last name</FormLabel>
                                        <Input name='last_name' type="text" value={EditUserForm.values.last_name} onChange={EditUserForm.handleChange} onBlur={EditUserForm.handleBlur} />
                                        {EditUserForm.errors.last_name && <Text fontSize='sm' color='red.400'>{EditUserForm.errors.last_name}</Text>}
                                    </FormControl>
                                </Box>
                            </HStack>
                            <HStack>
                                <Box minW={'50%'}>
                                    <FormControl id="email" isRequired mb={EditUserForm.errors.email ? 0 : 5}>
                                        <FormLabel>Email address</FormLabel>
                                        <Input name='email' type="email" value={EditUserForm.values.email} onChange={EditUserForm.handleChange} onBlur={EditUserForm.handleBlur} />
                                        {EditUserForm.errors.email && <Text fontSize='sm' color='red.400'>{EditUserForm.errors.email}</Text>}
                                    </FormControl>
                                </Box>
                                <Box minW={'50%'}>
                                    <FormControl id="phone" isRequired mb={EditUserForm.errors.phone ? 0 : 5}>
                                        <FormLabel>Phone number</FormLabel>
                                        <Input name='phone' type="tel" value={EditUserForm.values.phone} onChange={EditUserForm.handleChange} onBlur={EditUserForm.handleBlur} />
                                        {EditUserForm.errors.phone && <Text fontSize='sm' color='red.400'>{EditUserForm.errors.phone}</Text>}
                                    </FormControl>
                                </Box>
                            </HStack>
                            <HStack>
                                <Box minW={'50%'}>
                                    <FormControl id="gender" isRequired mb={EditUserForm.errors.gender ? 0 : 5}>
                                        <FormLabel>Gender</FormLabel>
                                        <Select name='gender' placeholder='Select gender' value={EditUserForm.values.gender} onChange={EditUserForm.handleChange} onBlur={EditUserForm.handleBlur}>
                                            <option value='male'>Male</option>
                                            <option value='female'>Female</option>
                                        </Select>
                                        {EditUserForm.errors.gender && <Text fontSize='sm' color='red.400'>{EditUserForm.errors.gender}</Text>}
                                    </FormControl>
                                </Box>
                                <Box minW={'50%'}>
                                    <FormControl id="role" isRequired mb={EditUserForm.errors.role ? 0 : 5}>
                                        <FormLabel>Role</FormLabel>
                                        <Select name='role' placeholder='Select role' value={EditUserForm.values.role} onChange={EditUserForm.handleChange} onBlur={EditUserForm.handleBlur}>
                                            <option value='driver'>Driver</option>
                                            <option value='mechanic'>Mechanic</option>
                                            <option value='admin'>Admin</option>
                                        </Select>
                                        {EditUserForm.errors.role && <Text fontSize='sm' color='red.400'>{EditUserForm.errors.role}</Text>}
                                    </FormControl>
                                </Box>
                            </HStack>
                            <Stack spacing={10} mt={3}>
                                <Button
                                    type='submit'
                                    size="lg"
                                    colorScheme={'yellow'}
                                    disabled={EditUserForm.isSubmitting || !EditUserForm.isValid}
                                    isLoading={EditUserForm.isSubmitting}
                                    onClick={handleSubmit}
                                    >
                                    Submit
                                </Button>
                            </Stack>
                        </form>
                    </Stack>
                </Box>
            </Stack>
            <ToastContainer />
        </Flex>
    );
};